import { getApiInstance } from '../helpers';

// old version
const getNumTickets = (): Promise<{
  [address: string]: {
    SI: number;
    NON_SI: number;
  };
}> => {
  console.time(`** TIME ** rest api: /ticket/count`);
  return getApiInstance()
    .get('/ticket/count')
    .then((res) => {
      console.info('/ticket/count', res.data);
      console.timeEnd(`** TIME ** rest api: /ticket/count`);
      return res.data;
    });
};

export const numTicketsService = {
  getNumTickets,
};
